webpackJsonp([70144966829960],{

/***/ 300:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _contact = __webpack_require__(300);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact() {
	    return _react2.default.createElement(
	        'div',
	        { id: 'contact-page' },
	        _react2.default.createElement(
	            'section',
	            { className: 'pageHeader', id: 'contact-header' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container py-5' },
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Contact'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'container small-container text-center' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 col-sm-8 offset-sm-2' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'If you have a query or would like further information on any of our services. Please email us at ',
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'text-orange' },
	                            'hello@kentweb.co.uk'
	                        ),
	                        ' or reach our via ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://twitter.com/KentWebApps' },
	                            'Twitter'
	                        ),
	                        '.',
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://twitter.com/KentWebApps?ref_src=twsrc%5Etfw', className: 'twitter-follow-button', 'data-show-count': 'false' },
	                            'Follow @KentWebApps'
	                        ),
	                        _react2.default.createElement('script', { async: true, src: 'https://platform.twitter.com/widgets.js', charSet: 'utf-8' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 text-center text-orange email-address' },
	                    'Hello@KentWeb.co.uk'
	                )
	            )
	        )
	    );
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-c27f2c7b6e3fee58aec1.js